import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";
import type { GridHeaderStyle } from "@inteacc/data-grid";
import type {
  InMemoryThemePreferenceProvider,
  ResolvedTheme,
  ThemeDensity,
  ThemePreference,
} from "@inteacc/theme";

export type ShowcaseTheme = "light" | "dark";
export type ShowcaseDensity = ThemeDensity;

export interface DisplayPreferences {
  density: ShowcaseDensity;
  gridHeaderStyle: GridHeaderStyle;
  setGridHeaderStyle: Dispatch<SetStateAction<GridHeaderStyle>>;
  provider: InMemoryThemePreferenceProvider;
  previewPreference: ThemePreference;
  resolvedTheme: ResolvedTheme;
  savedPreference: ThemePreference;
  setDensity: Dispatch<SetStateAction<ShowcaseDensity>>;
  setPreviewPreference: Dispatch<SetStateAction<ThemePreference>>;
  setSavedPreference: Dispatch<SetStateAction<ThemePreference>>;
  setTheme: Dispatch<SetStateAction<ShowcaseTheme>>;
  theme: ShowcaseTheme;
}

export const DisplayPreferencesContext =
  createContext<DisplayPreferences | null>(null);

export const useDisplayPreferences = (): DisplayPreferences => {
  const value = useContext(DisplayPreferencesContext);
  if (!value) throw new Error("Display preferences provider is missing.");
  return value;
};
